/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconExposureMinus1 = createReactComponent("outline", "exposure-minus-1", "IconExposureMinus1", [["path", { "d": "M3 12h6", "key": "svg-0" }], ["path", { "d": "M18 19v-14l-4 4", "key": "svg-1" }]]);

export { IconExposureMinus1 as default };
//# sourceMappingURL=IconExposureMinus1.mjs.map
